export const environment = {
  production: false,
  apiUrl: 'https://hris-api-dev.treantly.com',
};
